// src/components/legal/PrivacyPolicy.js
import React from 'react';

const PrivacyPolicy = () => {
  return (
    <div className="min-h-screen bg-gray-900 py-8 text-gray-100">
      <div className="max-w-4xl mx-auto px-4">
        <h1 className="text-3xl font-bold mb-6 text-blue-400">Privacy Policy</h1>
        
        <div className="bg-gray-800 rounded-lg shadow-md border border-gray-700 p-6 mb-6">
          <p className="text-gray-300 mb-6">
            Last updated: {new Date().toLocaleDateString('en-US', { year: 'numeric', month: 'long', day: 'numeric' })}
          </p>
          
          <h2 className="text-xl font-semibold mb-4 text-blue-300">Information We Collect</h2>
          <p className="text-gray-300 mb-4">
            We collect information you provide directly to us, such as when you create an account, update your profile, use the interactive features of our service, participate in contests, promotions, or surveys, request customer support or otherwise communicate with us.
          </p>
          
          <h2 className="text-xl font-semibold mb-4 text-blue-300">How We Use Information</h2>
          <p className="text-gray-300 mb-4">
            We use the information we collect to provide, maintain, and improve our services, such as to administer your account, deliver the services you request, and customize your experience with us.
          </p>
          
          <h2 className="text-xl font-semibold mb-4 text-blue-300">Information Sharing</h2>
          <p className="text-gray-300 mb-4">
            We do not share your personal information with companies, organizations, or individuals outside of bestboard.games except in the following cases:
            <ul className="list-disc pl-6 mt-2 space-y-1">
              <li>With your consent</li>
              <li>For legal reasons</li>
              <li>To protect bestboard.games</li>
            </ul>
          </p>
          
          <h2 className="text-xl font-semibold mb-4 text-blue-300">Cookies</h2>
          <p className="text-gray-300 mb-4">
            We use cookies and similar technologies to collect information about your activity, browser, and device. Most web browsers are set to accept cookies by default. If you prefer, you can usually choose to set your browser to remove or reject cookies.
          </p>

          <h2 className="text-xl font-semibold mb-4 text-blue-300">Analytics</h2>
          <p className="text-gray-300 mb-4">
            We collect analytics information about how you interact with our service to improve the user experience, troubleshoot issues, and enhance our offerings. This information is anonymized and used solely for the purpose of improving our service.
          </p>
                    
          <h2 className="text-xl font-semibold mb-4 text-blue-300">Data Security</h2>
          <p className="text-gray-300 mb-4">
            We take reasonable measures to help protect information about you from loss, theft, misuse and unauthorized access, disclosure, alteration and destruction.
          </p>
          
          <h2 className="text-xl font-semibold mb-4 text-blue-300">Children's Privacy</h2>
          <p className="text-gray-300 mb-4">
            Our services are not directed to children under 13. We do not knowingly collect personal information from children under 13. If we become aware that a child under 13 has provided us with personal information, we will take steps to delete such information.
          </p>
          
          <h2 className="text-xl font-semibold mb-4 text-blue-300">Changes to this Privacy Policy</h2>
          <p className="text-gray-300 mb-4">
            We may change this Privacy Policy from time to time. If we make changes, we will notify you by revising the date at the top of the policy and, in some cases, we may provide you with additional notice.
          </p>
          
          <h2 className="text-xl font-semibold mb-4 text-blue-300">Contact Us</h2>
          <p className="text-gray-300">
            If you have any questions about this Privacy Policy, please contact us at <a href="mailto:onlythebestboardgames@gmail.com" className="text-blue-400 hover:underline">onlythebestboardgames@gmail.com</a>.
          </p>
        </div>
      </div>
    </div>
  );
};

export default PrivacyPolicy;